// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionTabs_section__Zw6TW","sectionTab":"SectionTabs_sectionTab__xeG1Q"};